import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  useEffect(() => {
    document.title = '岡山市北区の訪問介護サービス｜ヘルパーステーションおかやま - 24時間365日対応で安心の在宅介護';
    
    // Add LocalBusiness Schema
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "ヘルパーステーションおかやま",
      "image": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/vite.svg`,
      "@id": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/`,
      "url": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/`,
      "telephone": "+81-86-012-3456",
      "faxNumber": "+81-86-012-3457",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "○○町1-2-3",
        "addressLocality": "岡山市北区",
        "addressRegion": "岡山県",
        "postalCode": "700-0000",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 34.6617,
        "longitude": 133.9185
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "09:00",
        "closes": "18:00"
      },
      "priceRange": "介護保険適用",
      "areaServed": {
        "@type": "City",
        "name": "岡山市北区"
      },
      "founder": {
        "@type": "Person",
        "name": "岡山太郎"
      },
      "foundingDate": "2020",
      "numberOfEmployees": 5
    });
    document.head.appendChild(schemaScript);

    return () => {
      if (schemaScript.parentNode) {
        schemaScript.parentNode.removeChild(schemaScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;